import React, { Fragment, useEffect, useState } from 'react';
import SignaturePadComponent from './SignaturePadComponent';
import ApplicationPreview from './ApplicationPreview';
import { Button, Checkbox, Input } from 'antd';
import { ServerAPI } from '../../common/ServerAPI';
import { toast } from 'react-toastify';
import ThankYouModal from './modals/ThankYouModal';
import { serverUrl } from '../../common/Constants';

const SIgnatureAcknowledgment = ({ }) => {
    const [signatureUpload, setSignatureUpload] = useState(false);
    const [acknowledgeValue, SetAcknowledgeValue] = useState(false);
    const [signatureAdded, setSignatureAdded] = useState(false);
    const [thankYou, setThankYou] = useState(false);
    const holderType = localStorage.getItem('holderType') ? localStorage.getItem('holderType') : "";
    const holderName = localStorage.getItem('holdername') ? localStorage.getItem('holdername') : "";
    const holderId = localStorage.getItem('holderId') ? localStorage.getItem('holderId') : "";

    const handleCopyTextToClipboard = () => {
        const textToCopy = serverUrl + "remote-sign?holderType=" + holderType + "&applicantionId=" + localStorage.getItem('applicationno') + "&holdername=" + holderName + "&holderId=" + holderId;
        const tempInput = document.createElement('input');
        tempInput.value = textToCopy;

        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);

        toast.success("text copied to clipboard");
    };

    const handleSaveSignature = async (dataUrl, stampUrl) => {
        let signatureObj = {
            "application": localStorage.getItem('applicationno'),
            "signature_type": holderType,
            "signature": dataUrl,
            "guarantor_id": holderId,
            "company_stamp": stampUrl ? stampUrl : "",
        };
        const response = await ServerAPI.signatureVerifier(signatureObj);
        if (response.resp_code == 200) {
            setSignatureAdded(true);
        }

    }
    return (
        <Fragment>

            <div className='w-screen' style={{ overflow: "hidden" }}>
                <p className="text-[18px] font-[700] p-[10px_0px] bg-white text-center">
                    New Loan Application
                </p>
                <ApplicationPreview holderId={holderId} view={'mobile'} />
            </div>
            <div style={{ background: "#ffff" }} className='rounded-lg mx-2 md:mx-5 md:p-5'>
                <div className="md:flex mx-2 md:mx-5 my-3 md:my-1">
                    {/* Mobile View */}
                    <div className="flex flex-col md:flex-row items-center md:hidden mb-3">
                        <p className="text-center md:text-left font-semibold text-[12px]">
                            Copy the link below and view the page on mobile devices for a better signing experience
                        </p>
                        <div className="flex mt-2  space-x-1">
                            <Input
                                className='mt-2'
                                type="text"
                                value={serverUrl + "remote-sign?holderType=" + holderType + "&applicantionId=" + localStorage.getItem('applicationno') + "&holdername=" + holderName + "&holderId=" + holderId}
                            />
                            <Button onClick={handleCopyTextToClipboard} type='primary' className='mt-2'>Copy</Button>
                        </div>
                    </div>
                    {/* Web View */}
                    <div className="hidden md:flex md:w-1/2 md:pr-4">
                        <p className="text-center md:text-left font-semibold text-[12px]">
                            Copy the link below and view the page on mobile devices for a better signing experience
                        </p>
                    </div>
                    <div className="md:w-1/2 md:pl-4">
                        <div className="flex flex-col md:flex-row md:items-center justify-center">
                            <div className="md:mr-2 lg:mr-3 mt-2 md:mt-0 flex">
                                <Checkbox
                                    className='mr-3 margin-checkbox-sign'
                                    id="acknowledge"
                                    onChange={(e) => {
                                        SetAcknowledgeValue(e.target.checked);
                                    }}
                                />
                                <label
                                    htmlFor="acknowledge"
                                    className="font-semibold text-[12px] cursor-pointer text-center"
                                >
                                    {holderType == 'applicant' ?
                                        "I acknowledge to give my full consent pertaining to my loan application."
                                        :
                                        "I acknowledge that I am willing to be the Guarantor for the Applicant/Hirer’s Loan Application"
                                    }
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="md:flex">
                    <div className="md:flex-1 mx-2 md:mx-5 mobile-hidden">
                        <Input
                            className='md:mr-2 lg:mr-3 md:w-[70%] lg:w-[66%]'
                            type="text"
                            value={serverUrl + "remote-sign?holderType=" + holderType + "&applicantionId=" + localStorage.getItem('applicationno') + "&holdername=" + holderName + "&holderId=" + holderId}
                        />
                        <Button onClick={handleCopyTextToClipboard} type='primary' className='md:mt-3 lg:mt-0'>Copy</Button>
                    </div>
                    <div className="md:flex-1 md:mt-3 lg:mt-0 flex justify-center items-center">
                        <Button disabled={!acknowledgeValue} onClick={() => {
                            setSignatureUpload(true);
                        }} type='primary' className='md:mt-3 lg:mt-0 mr-4 ml-4'>{signatureAdded == true ? "Re-Sign" : "Sign Now"}</Button>
                        {signatureAdded == true &&
                            <Button disabled={!acknowledgeValue} onClick={() => {
                                setThankYou(true);
                            }} type='primary' className='md:mt-3 lg:mt-0'>Submit</Button>
                        }
                    </div>
                </div>
            </div>

            <SignaturePadComponent
                visible={signatureUpload}
                onCancel={() => { setSignatureUpload(false) }}
                onSave={handleSaveSignature}
            />
            <ThankYouModal open={thankYou} close={()=>{setThankYou(false)}} />
        </Fragment>
    );
};

export default SIgnatureAcknowledgment;